import Accordion from "@mobi/ds/components/Accordion"
import Button from "@mobi/ds/components/Button"

import LabelValueList from "./components/LabelValueList/index"

import useSummaryAccordion from "./hooks"

import "./style.scss"

const SummaryAccordion = ({ isShareIncome, isSameAddress, isSameContact }) => {
  const { completeData, handleClickEdit } = useSummaryAccordion()

  return (
    <div className="summaryAccordion">
      {completeData.map(({ title, data: dataItem, targetStep, id }, index) => {
        if (id === "partnerShareIncome" && !isShareIncome) return null
        if (id === "partnerAddress" && !isSameAddress) return null
        if (id === "partnerContact" && !isSameContact) return null
        return (
          <Accordion title={title} index={index}>
            <LabelValueList data={dataItem} />
            <Button
              variant="action"
              className="summaryAccordion__actionButton"
              onClick={() => handleClickEdit(targetStep)}
            >
              editar
            </Button>
          </Accordion>
        )
      })}
    </div>
  )
}

export default SummaryAccordion
